import { Routes, Route, Navigate } from 'react-router-dom'

import ReceiveScanLogListView from 'Presentation/Views/ReceiveScanLog/List/View'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const ReceiveScanLogRoutes = () => (
  <Routes>
    <Route
      element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.receive_scan_log} />}>
      <Route index element={<ReceiveScanLogListView />} />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default ReceiveScanLogRoutes
